import axios from "axios";
import { API } from "./api";

// Auth now uses an httpOnly cookie set by the backend on /api/auth/verify.
// axios.defaults.withCredentials is enabled in api.js, so the cookie rides along.

export async function requestLink(email) {
  const res = await axios.post(`${API}/auth/request-link`, { email });
  return res.data;
}

export async function verifyToken(token) {
  const res = await axios.post(`${API}/auth/verify`, { token });
  return res.data;
}

export async function getMe() {
  const res = await axios.get(`${API}/auth/me`);
  return res.data;
}

export async function logoutRequest() {
  const res = await axios.post(`${API}/auth/logout`, {});
  return res.data;
}

export async function listAdmins() {
  const res = await axios.get(`${API}/auth/admins`);
  return res.data;
}

export async function addAdmin(email) {
  const res = await axios.post(`${API}/auth/admins`, { email });
  return res.data;
}

export async function removeAdmin(email) {
  const res = await axios.delete(`${API}/auth/admins/${encodeURIComponent(email)}`);
  return res.data;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
